var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConsultant = function SvgConsultant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5c34cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V8.5C7 7.122 5.876 6 4.491 6H3.51A2.5 2.5 0 0 0 1 8.5V11zM0 8.5C0 6.567 1.561 5 3.509 5h.982A3.507 3.507 0 0 1 8 8.5V12H0z"
  }))));
};
export default SvgConsultant;